<template>
	<div class="page_content explore_entity_inside career" aria-label="Career Co-curricular Page">

		<div class="row page-heading">
			<div class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-7 input module_heading">
      	<span class="module_icon ico-career"></span>
      	<template v-if="career && career.name">
          <career-title :career="career"></career-title>
        </template>
    	</div>
      <div class="col-xl-5 col-lg-5 col-md-6 col-sm-6 col-5 px-0">
    		<!--
        <b-dropdown :animation="animation" variant="link" no-caret class="create-section-menu">
      		<template slot="button-content">
        		<span class="icon-menu3x3"></span>
      		</template>
    		</b-dropdown>
        -->
				<div class="btn_container">
					<b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()">
            <span class="btn_ic ic-back"></span>
            <span class="btn_txt"> {{ deCamelCase() }} </span>
          </b-btn>
				</div>
      </div>
    </div>

      	<div class="page_content_container">

			<career-navigation :active="'cocurricular'" :code="code" :returnTo="returnTo"></career-navigation>

			<div class="pg_content">

				<b-jumbotron class="bg-gray">
              		<h4 class="text-center">Co-Curricular are coming soon</h4>
              		<!--<p class="text-center">Stay tuned for more information</p>-->
            	</b-jumbotron>

			</div> <!-- .pg_content -->

  		</div> <!-- .page_content_container -->

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CareerTitle from './CareerTitle'
import CareerNavigation from './CareerNavigation'

export default {
  name: 'careerCocurricular',
  props: ['code', 'returnTo'],
  components: {
    CareerTitle,
    CareerNavigation
  },
  data: () => {
    return {
      career: {}
    }
  },

  mounted () {
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadLogDashboardActivity'
    ]),
    returnToClicked () {
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return result
    }
  },

  computed: {
    ...mapState({
    })
  },

  watch: {
  }
}
</script>
<style>
.jumbotron {
  background: #fffff;
}
.text-center {
  text-align: center;
}
.bg-gray{
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerCocurricular.vue